module.exports = __webpack_public_path__ + "static/media/house4.c10849f0.png";